// Lookups shared by the line-item form controllers
// (line-item-form, line-item-rows, line-item-quantity-helpers).

const DAY_MS = 24 * 60 * 60 * 1000

// The page can host several hw-combobox instances with this hidden-input name
// (modal + parent page): scope to the form and take the first input with a value.
export function currentFieldTaskId(scope) {
  for (const input of scope.querySelectorAll('input[name="field_cycle_line_item[field_task_id]"]')) {
    if (input.value) return input.value
  }
  return ""
}

// Shared scheduled dates: checked boxes in the date grid.
export function sharedDateValues(scope) {
  const inputs = scope.querySelectorAll(
    'input[name="field_cycle_line_item[scheduled_dates][]"]:checked',
  )
  return sortedUniqueDates(Array.from(inputs, (input) => input.value))
}

// A row's effective dates: its open date override, otherwise the shared dates.
export function rowDateValues(row, scope) {
  const override = row.querySelector("[data-dates-override]")
  if (!override || override.classList.contains("hidden")) return sharedDateValues(scope)

  const checked = override.querySelectorAll('input[type="checkbox"]:checked')
  return sortedUniqueDates(Array.from(checked, (input) => input.value))
}

// Consecutive dates make one continuous task; a gap starts a separate task.
export function consecutiveDateGroups(dateValues) {
  const groups = []
  dateValues.forEach((dateValue) => {
    const group = groups[groups.length - 1]
    if (group && daysBetween(group[group.length - 1], dateValue) === 1) group.push(dateValue)
    else groups.push([dateValue])
  })
  return groups
}

function sortedUniqueDates(dateValues) {
  return Array.from(new Set(dateValues)).sort((a, b) => Date.parse(a) - Date.parse(b))
}

function daysBetween(earlier, later) {
  return Math.round((Date.parse(later) - Date.parse(earlier)) / DAY_MS)
}
